import React from 'react';

export const SERVICES = [
  { num:'01', name:'Web Development', path:'M2 3h20v14H2zM8 21h8M12 17v4', desc:'Fast, scalable, pixel-perfect websites built for performance and conversion.' },
  { num:'02', name:'App Development', path:'M5 2h14a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zM12 18h.01', desc:'Native and cross-platform mobile apps that users love every day.' },
  { num:'03', name:'Digital Marketing', path:'M22 12h-4l-3 9L9 3l-3 9H2', desc:'Data-driven campaigns that turn clicks into customers across every channel.' },
  { num:'04', name:'SEO Optimization', path:'M11 11m-8 0a8 8 0 1 0 16 0 8 8 0 0 0-16 0M21 21l-4.35-4.35', desc:'Dominate search rankings and drive organic traffic that compounds.' },
  { num:'05', name:'UI/UX Design', path:'M12 12m-3 0a3 3 0 1 0 6 0 3 3 0 0 0-6 0M12 2v2M12 20v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M2 12h2M20 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42', desc:'Intuitive interfaces and seamless experiences that delight and retain.' },
  { num:'06', name:'Branding', path:'M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5', desc:'Strategic brand identities that stand out, resonate, and build loyalty.' },
  { num:'07', name:'Video Editing', path:'M23 7l-7 5 7 5V7z', path2:'M1 5h15a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H1V5z', desc:'Cinematic content that tells your story and stops the scroll.' },
  { num:'08', name:'Social Media Management', path:'M17 2H7a5 5 0 0 0-5 5v10a5 5 0 0 0 5 5h10a5 5 0 0 0 5-5V7a5 5 0 0 0-5-5z', path2:'M12 9m-3 0a3 3 0 1 0 6 0 3 3 0 0 0-6 0', desc:'Grow your audience with strategic, consistent social content everywhere.' },
];

export const TESTIMONIALS = [
  { name:'Aryan Khan', role:'CEO, NovaTech Solutions', initials:'AK', text:'WebDigiting completely transformed our online presence. Within 3 months their SEO work doubled our organic traffic and tripled our leads.' },
  { name:'Sofia Ramos', role:'Founder, Bloom Wellness', initials:'SR', text:'The app was delivered on time and exceeded every expectation. The UI is beautiful, performance flawless — users love it.' },
  { name:'James Mwangi', role:'CMO, Verve Retail Group', initials:'JM', text:'Their branding work gave us a completely fresh identity. The team understood our vision immediately and delivered beyond expectations.' },
];

export const getFooterHref = (label) => {
  if (label === 'About Us') return '/about';
  if (label === 'Contact') return '#contact';
  if (label === 'Blog') return '/blog';
  if (label === 'Our Work') return '/work';
  if (label === 'Reviews') return '/reviews';
  if (label === 'Terms of Service') return '/terms';
  if (label === 'Privacy Policy') return '/privacy';
  return `#${label.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '')}`;
};

export const Icon = ({ path, path2, size = 40 }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ width: size, height: size }}>
    <path d={path} />
    {path2 && <path d={path2} />}
  </svg>
);

export const Stars = () => (
  <div style={{ display: 'flex', gap: 3, marginBottom: 16 }}>
    {[...Array(5)].map((_, i) => (
      <svg key={i} viewBox="0 0 24 24" style={{ width: 13, height: 13, fill: 'var(--accent)' }}>
        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
      </svg>
    ))}
  </div>
);
